import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import Screenshot from './Screenshot';

const FeatureCard = ({ feature }) => {
    const { name, icon, desc, bullets, screenshot, thumbnail, adminLink } = feature;
    const [isZoomed, setIsZoomed] = useState(false);

    // 라이트박스가 열린 동안 ESC 키 닫기 + body 스크롤 잠금
    useEffect(() => {
        if (!isZoomed) return;
        const onKey = (e) => { if (e.key === 'Escape') setIsZoomed(false); };
        window.addEventListener('keydown', onKey);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            window.removeEventListener('keydown', onKey);
            document.body.style.overflow = prevOverflow;
        };
    }, [isZoomed]);

    const openZoom = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsZoomed(true);
    };

    return (
        <article className="intro-feature">
            <div className="intro-feature__shot">
                {thumbnail ? (
                    <div className="intro-feature__thumb"
                         onClick={openZoom}
                         role="button"
                         tabIndex={0}
                         onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openZoom(e); }}
                         title="이미지 크게 보기">
                        <img src={thumbnail} alt={name + ' 화면 미리보기'} loading="lazy" />
                        <span className="intro-feature__zoom-hint">
                            <FeatherIcon icon="zoom-in" size="14" />
                            <span>확대 보기</span>
                        </span>
                    </div>
                ) : (
                    <Screenshot file={screenshot} alt={name + ' 화면 미리보기'} />
                )}
            </div>
            <div className="intro-feature__body">
                <div className="intro-feature__head">
                    <span className="intro-feature__icon">
                        <FeatherIcon icon={icon || 'check'} size="16" />
                    </span>
                    <h3>{name}</h3>
                </div>
                <p className="intro-feature__desc">{desc}</p>
                {Array.isArray(bullets) && bullets.length > 0 && (
                    <ul className="intro-feature__bullets">
                        {bullets.map((b, i) => (
                            <li key={i}>
                                <FeatherIcon icon="check" size="13" />
                                <span>{b}</span>
                            </li>
                        ))}
                    </ul>
                )}
                {adminLink && (
                    <Link to={adminLink} className="intro-feature__more">
                        어드민에서 직접 확인하기 <FeatherIcon icon="arrow-right" size="13" />
                    </Link>
                )}
            </div>

            {isZoomed && thumbnail && ReactDOM.createPortal(
                <div className="intro-lightbox"
                     onClick={() => setIsZoomed(false)}
                     role="dialog"
                     aria-modal="true"
                     aria-label={name + ' 확대 보기'}>
                    <button type="button"
                            className="intro-lightbox__close"
                            onClick={(e) => { e.stopPropagation(); setIsZoomed(false); }}
                            title="닫기 (ESC)">
                        <FeatherIcon icon="x" size="22" />
                    </button>
                    <figure className="intro-lightbox__figure" onClick={(e) => e.stopPropagation()}>
                        <img src={thumbnail} alt={name} />
                        <figcaption>{name}</figcaption>
                    </figure>
                </div>,
                document.body
            )}
        </article>
    );
};

export default FeatureCard;
